import { dapiDefaults } from './defaults';
import CmsDapiModel from '../models/CmsDapiModel';

export default {
    ...dapiDefaults,
    model: CmsDapiModel,
    namespace: 'cmsdapi',
    expires: 300,
    pathTemplate: '{locale}/stories?tags.slug=gamepk-{gamePk}&$limit={limit:5}&$sort=contentDate:{sort:desc}'
};
